export class Language {
  constructor(
    public kaz: string,
    public rus: string) {

  }
}



// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/app/model/lang.model.ts